jQuery(document).ready(function ($) {
	setTimeout(() => $('.loader').removeClass('show'), 1000)

	// Slider
	if ($('.images-slider').length > 0) {
		$('.images-slider').owlCarousel({
			items: 3,
			loop: true,
			margin: 30,
			center: true,
			autoplay: true,
			autoplayTimeout: 5000,
			smartSpeed: 1500,
			autoplaySpeed: true,
			autoplayHoverPause: true,
			autoWidth: true,
			dots: true
		});
	}

	if ($('.images-slider.video').length > 0) {
		$('.images-slider.video').owlCarousel({
			items: 3,
			loop: true,
			margin: 30,
			center: true,
			autoplay: true,
			video: true,
			autoplayTimeout: 5000,
			smartSpeed: 1500,
			autoplaySpeed: true,
			autoplayHoverPause: true,
			autoWidth: true,
			videoWidth: true, // Default false; Type: Boolean/Number
			videoHeight: true, // Default false; Type: Boolean/Number
			dots: true
		});
	}
});